import { render, staticRenderFns } from "./D365DetailTable.vue?vue&type=template&id=0451379f"
import script from "./D365DetailTable.vue?vue&type=script&lang=js"
export * from "./D365DetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports